<template>
	<v-card>
		<v-card-title>Start Phone Appointment</v-card-title>
		<v-card-text class="mt-2">
			<div v-if="submitted">
				<v-progress-linear indeterminate color="primary"></v-progress-linear>
				<p class="mt-2">
					{{status}}
				</p>
			</div>
			<div v-else>
				Our telephone system will initiate a call between you and the respondent. Please enter your telephone number to receive this call. 
				<v-text-field class="mt-3" v-model="phoneNumber" label="Your Phone Number"></v-text-field>
				
			</div>
		</v-card-text>
		<v-card-actions class="mt-2">
			<v-spacer></v-spacer>
			<v-btn color="green" dark @click="startCall" v-if="!submitted">Start Call</v-btn>
			<v-btn color="primary" text  v-else>I haven't received a call</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
	import Vuex from "vuex"
	export default {
		name: "StartPhone",
		props: {
			appointment: {type: Object}
		},
		data: () => {
			return {
				submitted: false, 
				phoneNumber: '', 
				sessionId: false

			}
		},
		computed: {
			...Vuex.mapState( {
				user: state => state.auth.user, 
				userDetails: state => state[state.auth.view].user,
				phoneSession(state){
					if( !this.sessionId) {
						return;
					}
					var sessionId = this.sessionId;
					return state[state.auth.view].phoneSessions.find( a => a.id == sessionId )
				}, 
			}),
			status(){
				if( !this.phoneSession ){
					return "";
				}
				if( this.phoneSession.status == "calling" ){
					return "Phone appointment initiated - please wait"
				}
				if( this.phoneSession.status == "queued" ){
					return "Call queued - please wait"
				}
				return "";
			}
		},	
		methods:{
			startCall() {
				const self = this;
				this.$store.dispatch("addDoc", {
					collection: "phoneSessions", 
					data: {
						appointment: self.appointment.id, 
						user: self.user.uid, 
						phoneNumber: self.phoneNumber, 
						status: "notstarted"
					}
				}).then( (r) => {
					self.submitted = true;
					self.sessionId = r.id;
				})
			}
		}, 
		watch: {
			sessionId(){
				this.$store.dispatch("trackPhoneSession", this.sessionId )
			}
		},
		created() {
			if( this.userDetails.phone ){
				this.phoneNumber = this.userDetails.phone
			}
		}
	}
</script>